import React, {useEffect, useState } from "react";
import PositionalPage from "./components/PositionalPage";
import SwingPage from "./components/SwingPage";
import ReservedPage from "./components/ReservedPage";
import IntradayPage from "./components/IntradayPage";
import './portfoliopage.css'
import { useLocation, useOutletContext } from "react-router-dom";
import ProfileHeader from "../../profile/components/ProfileHeader";
import ClientSummaryCard from "./components/ClientSummaryCard";

const PortfolioPage = () => {
  const {state} = useLocation();
  // console.log(state.clientData);
  const [client,setClient] = useState({});
  const { openSidebar } = useOutletContext();

  useEffect(()=>{
    if(state?.clientData){
      setClient(state?.clientData)
    }
  },[state])

  // const loading = true;

  const [activeTab,setActiveTab] = useState("positional");

  // if (loading) {
  //   return (
  //     <div className="loading-loading-loading-row">
  //       <div className="loading-loading-loading-card">
  //         <h3 className="loading-loading-loading-title">Loading...</h3>

  //         <div className="loading-loading-spinner-wrapper">
  //           <div className="loading-loading-spinner"></div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // console.log(client);

  if (!client?.portfolioAllocation) {
    return <div>Loading...</div>;
  }


  const data = {
    positional:client.portfolioAllocation.positional || '',
    swing: client.portfolioAllocation.swing || '',
    intraday:client.portfolioAllocation.intraday || '',
    reserved:client.portfolioAllocation.reserved || ''
  };


  const tabs = ["positional","swing","intraday","reserved"];

  return (
    <div className="rp-leads-page">
       <ProfileHeader onMenuClick={openSidebar} val="Client Portfolio" />
       <ClientSummaryCard client={client} />
        <div className="customer-port-folio-portfolio-tabs">
            {tabs.map((tab)=>(
            <button
            key={tab}
            className={`customer-port-folio-portfolio-tab ${activeTab===tab?"active":""}`}
            onClick={()=>setActiveTab(tab)}
            >
            {tab.toUpperCase()}
            </button>
            ))}
        </div>
        <div className="customer-port-folio-tabs">
          {activeTab==="positional" && <PositionalPage data={data.positional} />}
          {activeTab==="swing" && <SwingPage data={data.swing} />}
          {activeTab==="intraday" && <IntradayPage data={data.intraday} />}
          {activeTab==="reserved" && <ReservedPage data={data.reserved} />}
        </div>
    </div>

  );
};

export default PortfolioPage;